<div class="viewer-zoom d-flex flex-column">
  <div class="sr-only" role="status" aria-live="polite">{{ statusMessage }}</div>
  <div class="viewer-zoom-buttons">
    <div class="zoom-control">
      <zbp-button-component id="zoomButton"
                            [ngbPopover]="popoverControl?.popoverContent"
                            popoverClass="viewer-control-popover"
                            [popperOptions]="popperOptions"
                            [autoClose]="'outside'"
                            (shown)="showPopover()"
                            (hidden)="closePopover()"
                            [placement]="isDesktop ? 'right' : 'top'"
                            container="body"  
                            [openDelay]="0"
                            [closeDelay]="0"
                            [theme]="'viewerControl'"
                            [borderRadius]="'0'"
                            [label]="'zoom'"
                            [ariaLabel]="'zoom'"
                            [ariaExpanded]="isPopoverOpen"
                            [iconPosition]="'top'"
                            [iconName]="zbpIconNames.magnifyingGlassWithPlusIcon"
                            #popover="ngbPopover"
                            [customClass]="'viewer-asset-control-button'"
      >
      </zbp-button-component>

      <zbp-viewer-control-popover #popoverControl="ControlPopoverComponent"
                                  title="ZOOM"
                                  (shouldClosePopover)="popover.close()"
                                  [hidden]="true">
        <div class="zoom-content">
          <zbp-button-component id="zoomOutButton"
                                type="button"
                                [ariaLabel]="'Zoom Out, current zoom is ' + zoomLevel + '%'"
                                [disabled]="zoomLevel <= zoomMin"
                                (clickHandler)="handleZoomOut()"
                                [extraHorizontalPadding]="true"
                                [theme]="'viewerPopoverSingleCharacter'"
                                [label]="'-'">
          </zbp-button-component>
          <div class="zoom-percent">{{ zoomLevel }}%</div>
          <zbp-button-component id="zoomInButton"
                                type="button"
                                [ariaLabel]="'Zoom In, current zoom is ' + zoomLevel + '%'"
                                [disabled]="zoomLevel >= zoomMax"
                                (clickHandler)="handleZoomIn()"
                                [extraHorizontalPadding]="true"
                                [theme]="'viewerPopoverSingleCharacter'"
                                [label]="'+'">
          </zbp-button-component>
        </div>
        <div class="reset-zoom">
          <zbp-button-component id="resetZoom"
                                type="button"
                                [ariaLabel]="'Reset zoom to 100%'"
                                [theme]="'transparentWhite'"
                                [fontSizeUnit]="'rem'"
                                [label]="'reset to 100%'"
                                (clickHandler)="resetZoom()">
          </zbp-button-component>
        </div>
      </zbp-viewer-control-popover>
    </div>

  </div>
</div>
